// extracted by mini-css-extract-plugin
module.exports = {"case":"Case_case__1LOKh","container":"Case_container__QYbKM"};